import { COUNTRY } from "./app";

export const defaultSchema: any = {
    [COUNTRY.AUS]: {
        "@context": "https://schema.org",
        "@type": "MovieTheater",
        "url": "https://readingcinemas.com.au",
        "name": "Reading Cinemas",
        "logo": "https://d2apwscfoijj3f.cloudfront.net/assets/images/reading-cinemas-logo-white.svg",
        "sameAs": ['https://www.facebook.com/readingcinemasaustralia',
            'https://www.instagram.com/readingcinemasau',
            'https://www.tiktok.com/@readingcinemasaus',
        ]
    },
    [COUNTRY.NZ]: {
        "@context": "https://schema.org",
        "@type": "MovieTheater",
        "url": "https://readingcinemas.co.nz",
        "name": "Reading Cinemas",
        "logo": "https://d2apwscfoijj3f.cloudfront.net/assets/images/reading-cinemas-logo-white.svg",
        "sameAs": ['https://www.facebook.com/ReadingCinemasNewZealand',
            'https://www.instagram.com/readingcinemasnz',
        ]
    },
    [COUNTRY.ANG]: {
        "@context": "https://schema.org",
        "@type": "MovieTheater",
        "url": "https://angelikacinemas.com.au",
        "name": "Angelika Cinemas",
        "logo": "https://d2apwscfoijj3f.cloudfront.net/assets/images/angelika-logo.svg",
        "sameAs": ['https://www.facebook.com/angelikafilmcentre',
            'https://www.instagram.com/angelikaaustralia',
            'https://www.tiktok.com/@angelika.cinemas'
        ]
    },
    [COUNTRY.STA]: {
        "@context": "https://schema.org",
        "@type": "MovieTheater",
        "url": "https://statecinema.com.au",
        "name": "State Cinema",
        "logo": "https://d2apwscfoijj3f.cloudfront.net/assets/images/StateLogo.png",
        "sameAs": ['https://www.facebook.com/StateCinema',
            'https://www.instagram.com/statecinemahobart',
            'https://www.tiktok.com/@thestatecinema'
        ]
    }
}